<template>
  <div class="wrapper">
    <ol class="c-stepper">
      <li
        v-for="index in steps.length"
        :key="index"
        :class="c_stepper_item(index)"
        @click="clickStep(index)"
      >
        <h3
          :class="
            index == step ? 'c-stepper__title active' : 'c-stepper__title'
          "
        >
          <span v-if="step <= index">{{ index }}</span>
          <span else><i class="fa"></i></span>
        </h3>
        <p class="c-stepper__desc">{{ steps[index-1] }}</p>
      </li>
    </ol>
    <!-- Step now: {{ step }} -->
  </div>
</template>

<script>
export default {
  name: "wizard-stepper",
  props: {
    step: { type: Number, default: 0 },
    steps: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      step: 0,
    };
  },
  methods: {
    clickStep(step) {
      this.step = step;
      this.$emit("click", step);
    },
    c_stepper_item(index) {
      if (this.step > index) {
        return "c-stepper__item done";
      } else if (this.step == index) {
        return "c-stepper__item active";
      } else {
        return "c-stepper__item";
      }
    },
  },
};
</script>

<style lang="scss">
/*WIZARD STEPPER*/
:root {
  --circle-size: clamp(1.5rem, 5vw, 3rem);
  --spacing: clamp(0.25rem, 2vw, 0.5rem);
}

.wrapper {
  max-width: 1000px;
  //   margin: 2rem auto 0;
}

.c-stepper {
  display: flex;
  padding-left: 0;
}

.c-stepper__item {
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;

  &:before {
    --size: 3rem;
    content: "";
    display: block;
    width: var(--circle-size);
    height: var(--circle-size);
    border-radius: 50%;
    background-color: #ced2d8;
    //opacity: 0.5;
    margin: 0 auto 1rem;
    cursor: pointer;
    border: 6px solid #ced2d8;
  }

  &:not(:last-child) {
    &:after {
      content: "";
      //  content: "\2713 ";
      position: relative;
      top: calc(var(--circle-size) / 2);
      width: calc(100% - var(--circle-size) - calc(var(--spacing) * 2));
      left: calc(50% + calc(var(--circle-size) / 2 + var(--spacing)));
      height: 2px;
      background-color: #ced2d8;
      order: -1;
    }
  }
}

.c-stepper__item.done {
  &:before {
    background-color: #3cb450;
    content: "\2713 ";
    color: #fff;
    font-size: 24px;
    border: 6px solid #3cb450;
  }

  &:not(:last-child) {
    &:after {
      //content: "\2713 ";
      background-color: #3cb450;
    }
  }
}

.c-stepper__title {
  font-weight: bold;
  font-size: clamp(1rem, 4vw, 1.25rem);
  margin-bottom: 0.5rem;
  margin-top: -3.3rem;

  &.active {
    //color: #ced2d8;
    color: #3b5343;
  }
  &.done {
    content: "";
  }
}
.c-stepper__item.active:before {
  border: 6px solid #3cb450;
  background: white;
  color: #4f5d73;
}
.c-stepper__item:hover {
  color: #3cb450 !important;
  cursor: pointer; 
}
.c-stepper__item:hover::before {
  color: #ced2d8 !important;
  border: 6px solid #3cb450;
}
.c-stepper__item.done:hover::before {
  color: #ced2d8 !important;
}

.c-stepper__desc {
  color: #636f83;
  font-size: clamp(0.85rem, 2vw, 1rem);
  padding-left: var(--spacing);
  padding-right: var(--spacing);
  padding-top: 0.5rem;
}
.c-dark-theme .c-stepper__desc {
  color: #e1e1e1;}

/*END WIZARD STEPPER*/
</style>